import React, { Component } from 'react'
import MathJax from 'react-mathjax2'
import './EquationControl.scss'

export default class EquationControl extends Component {
    constructor(props) {
        super(props)

        this.state = {
            editable: true
        }
    }

    onChange = (e) => {
        this.setState({
            value: e.target.value
        })
    }

    editFormula = () => {
        this.setState({ editable: true }, () => {
            this.inputBox.focus()
        })
    }

    render() {
        let { item, onInput, readOnly } = this.props
        let { editable } = this.state

        if (!readOnly) {
            return ([
                <>
                    {
                        editable ? (
                            <div ref={el => this.inputBox = el} onBlur={(e) => { onInput(e, this) }} id={item.name} className='editor-contenteditable equation-input' contentEditable='true' >
                                { item.value}
                            </div>
                        ) : null
                    }
                </>,
                <>
                    {
                        !editable ? (
                            <MathJax.Context input='ascii'>
                                <div className='equation-converted' onDoubleClick={this.editFormula}>
                                    <MathJax.Node inline>{item.value}</MathJax.Node>
                                </div>
                            </MathJax.Context>
                        ) : null
                    }
                </>
            ])
        } else {
            return ([
                <MathJax.Context input='ascii'>
                    <div className='equation-converted readOnly'>
                        <MathJax.Node inline>{item.value}</MathJax.Node>
                    </div>
                </MathJax.Context>
            ])
        }
    }
}
